import * as React from "react";
const SvgFoodSafetySpecialist = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 55, height: 51, viewBox: "0 0 55 51", fill: "none", ...props }, "...");
export default SvgFoodSafetySpecialist;
